import React, { useMemo } from 'react';
import { BdsTableCell, BdsTableRow, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { useAiTokenConsumptionContext } from '../../../../contexts/Billing/AiTokenConsumptionContext';
import { useAiTokenConsumptionDataContext } from '../../../../contexts/Billing/AiTokenConsumptionDataContext';
import TableWithPagination from '../../../../components/TableWithPagination/TableWithPagination';
import { useSortedPaginatedData } from '../../../../hooks/useSortedPaginatedData';
import { DEFAULT_PAGE_OPTIONS, COLUMN_WIDTHS_2 } from '../../../../utils/paginationUtils';
import { AiTokenConsumptionPaper, DailyTitleContainer } from '../styles';

const COLUMN_KEYS = ['botName', 'aiToken'];

const AiTokenConsumptionBotUsage: React.FC = () => {
  const { content } = useAiTokenConsumptionContext();
  const { botAiTokenConsumption, isAiTokenLoading } = useAiTokenConsumptionDataContext();

  const {
    itemsPerPage,
    sortConfig,
    sortedData,
    paginatedData,
    handlePaginationChange,
    handleItemsPerPageChange,
    handleSortChange,
  } = useSortedPaginatedData({ data: botAiTokenConsumption });

  const tableRows = useMemo(
    () =>
      paginatedData.length > 0
        ? paginatedData.map((item) => (
            <BdsTableRow key={item.botName}>
              <BdsTableCell>
                <BdsTypo variant="fs-14" bold="bold" margin={false}>
                  {item.botName}
                </BdsTypo>
              </BdsTableCell>
              <BdsTableCell>
                <BdsTypo variant="fs-14" margin={false}>
                  {item.aiToken.toLocaleString(content.locale)}
                </BdsTypo>
              </BdsTableCell>
            </BdsTableRow>
          ))
        : undefined,
    [paginatedData, content.locale],
  );

  return (
    <AiTokenConsumptionPaper>
      <DailyTitleContainer>
        <BdsTypo variant="fs-24" bold="bold" margin={false}>
          {content.botConsumption.title}
        </BdsTypo>
        <BdsTypo variant="fs-14" margin={false}>
          {content.botConsumption.description}
        </BdsTypo>
      </DailyTitleContainer>
      <TableWithPagination
        options={{
          heading: [content.botConsumption.columnName, content.botConsumption.columnTotalTokens],
          columnKeys: COLUMN_KEYS,
          columnWidths: COLUMN_WIDTHS_2,
          sortConfig,
          onSortChange: handleSortChange,
          itemsPerPageList: DEFAULT_PAGE_OPTIONS,
          itemsPerPage,
          numberOfItems: isAiTokenLoading ? itemsPerPage : sortedData.length,
          isLoading: isAiTokenLoading,
          hasEmptyState: !isAiTokenLoading && sortedData.length === 0,
          emptyStateSubtitle: '',
          isAutoHeight: true,
        }}
        onPaginationChange={handlePaginationChange}
        onItemsPerPageChange={handleItemsPerPageChange}
      >
        {tableRows}
      </TableWithPagination>
    </AiTokenConsumptionPaper>
  );
};

export default AiTokenConsumptionBotUsage;
